import React from 'react'
import {connect} from 'react-redux'
import R from 'ramda'

import MapWithControls from './MapWithControls'
import EstateMarker from './EstateMarker'
import GroupMarker from './GroupMarker'
import PoiMarker from './PoiMarker'
import ServiceMarker from './ServiceMarker'
import Boundaries from './Boundaries'
import Paths from './Paths'
import StatelessFuncToPureComponent from './StatelessFuncToPureComponent'
import FitOnSearchChange from './FitOnSearchChange'

import updateViewPort from '../actions/updateViewPort'
import getPositioningBoundary from '../actions/getPositioningBoundary'
import hideBoundaries from '../actions/hideBoundaries'
import setServiceIds from '../actions/setServiceIds'

import getCurrentQuery from '../utils/getCurrentQuery'

import visibleEstatesOnMap from '../selectors/visibleEstatesOnMap'
import partionEstateMapByMatch from '../selectors/partionEstateMapByMatch'
import {nonMatchingEstatesSelector, matchingEstatesSelector, groupsSelector, listsOfEstatesSelector} from '../selectors/groupEstatesByProximity'

import loadSummaries from '../actions/loadSummaries'
import MapSetter from './MapSetter'
import sortedEstateList from '../selectors/sortedEstateList'

const estateToEstateMarker = matching => (estate) => {
  return <EstateMarker key={estate.id} estate={estate} matchSearch={matching}/>
}
const groupToMarker = (group) => {
  return <GroupMarker 
    key={`${group.coordinates.lat}_${group.coordinates.lng}`} 
    coordinates={group.coordinates} 
    estates={group.estates}
    bounds={group.bounds}/>
}
const poiToMarker = (poi) => {
  if(poi.type) { return null }
  return <PoiMarker key={poi.markerCount} poi={poi}/>
}

const serviceToMarker = (service) => {
  return <ServiceMarker 
    key={`${service.name}-${service.coordinates.lat}, ${service.coordinates.lng}`} 
    address={service.address} 
    name={service.name} 
    coordinates={service.coordinates}
    type={service.type}
  />
}


class MapWithEstates extends React.Component {
  shouldComponentUpdate(nextProps){
    return !R.equals(nextProps, this.props)
  }
  render() {
    const {
      //matchingEstates,
      //nonMatchingEstates,
      groups, 
      listsOfEstates,
      defaultViewPort, 
      services,
      serviceIds,
      onMapMove, 
      onSetServiceIds, 
      onShowPositioningBounds, 
      onHideBoundaries,
      showBoundaries,
      updateSummaries,
      zoom,
      viewPort,
      estateMap,
      estateListIdsIndex,
      sortedEstates,
      selectedEstateId
    } = this.props
    const query = getCurrentQuery()

    const getEstates = x => x.estates[0];
    var listEstates = R.map(getEstates,listsOfEstates); 

    var estateListIdsIndexWithScore = [];

    for(var j=0; j<sortedEstates.length; j++)
    {
      estateListIdsIndexWithScore[sortedEstates[j].id] = {}
      estateListIdsIndexWithScore[sortedEstates[j].id].index = j;
      estateListIdsIndexWithScore[sortedEstates[j].id].pertinenceScore = sortedEstates[j].pertinenceScore;
      estateListIdsIndexWithScore[sortedEstates[j].id].proximityScore = sortedEstates[j].proximityScore;
    }

    var matchingEstates = [];
    for(var i=0; i<listEstates.length; i++)
    {
      if(estateListIdsIndex[listEstates[i].id])
      {
        matchingEstates.push(listEstates[i]);
        matchingEstates[matchingEstates.length-1].index = estateListIdsIndexWithScore[listEstates[i].id].index;
        matchingEstates[matchingEstates.length-1].pertinenceScore = estateListIdsIndexWithScore[listEstates[i].id].pertinenceScore;
        matchingEstates[matchingEstates.length-1].proximityScore = estateListIdsIndexWithScore[listEstates[i].id].proximityScore;
      }
    }

    var nonMatchingEstates = [];
    for(var i=0; i<listEstates.length; i++)
    {
      if(!estateListIdsIndex[listEstates[i].id])
      {
        nonMatchingEstates.push(listEstates[i]);
      }
    }
        
    var visibleMatchingEstates = [];
    for(var i=0; i<matchingEstates.length; i++)
    {
      if(matchingEstates[i].coordinates.lat > viewPort.bottomRight.lat && 
         matchingEstates[i].coordinates.lat < viewPort.topLeft.lat &&
         matchingEstates[i].coordinates.lng < viewPort.bottomRight.lng &&
         matchingEstates[i].coordinates.lng > viewPort.topLeft.lng)
      {
        visibleMatchingEstates.push(matchingEstates[i])
      }
    }

    var visibleNonMatchingEstates = [];
    for(var i=0; i<nonMatchingEstates.length; i++)
    {
      if(nonMatchingEstates[i].coordinates.lat > viewPort.bottomRight.lat && 
         nonMatchingEstates[i].coordinates.lat < viewPort.topLeft.lat &&
         nonMatchingEstates[i].coordinates.lng < viewPort.bottomRight.lng &&
         nonMatchingEstates[i].coordinates.lng > viewPort.topLeft.lng)
      {
        visibleNonMatchingEstates.push(nonMatchingEstates[i])
      }
    }
    
    var matchingEstateMarkers = R.map(estateToEstateMarker(true), visibleMatchingEstates)
    var nonMatchingEstateMarkers = R.map(estateToEstateMarker(false), visibleNonMatchingEstates)

    var selectedEstate;
    if(typeof R.find(R.propEq('id',selectedEstateId))(listEstates) === 'undefined')
    {
      selectedEstate = R.find(R.propEq('id',selectedEstateId))(estateMap);
    }


    if(typeof selectedEstate !== 'undefined')
    {
      var selectedEstateMarker;
      if(estateListIdsIndex[selectedEstate.id])
      {
        selectedEstateMarker = estateToEstateMarker(true)(selectedEstate);
        matchingEstateMarkers.push(selectedEstateMarker);
      }
      else
      {
        selectedEstateMarker = estateToEstateMarker(false)(selectedEstate);
        nonMatchingEstateMarkers.push(selectedEstateMarker);
      }
    }
    
    const groupMarkers = R.map(groupToMarker, groups)
    const poisMarkers = R.map(poiToMarker, query.pois)
    const servicesMarkers = R.map(serviceToMarker, services)
    
    const toggleShowPositioningBounds = _ => {
        if(showBoundaries)
           onHideBoundaries();
        else 
           onShowPositioningBounds();
    }

    updateSummaries(visibleNonMatchingEstates);
    
    var map = <MapWithControls 
        defaultViewPort={defaultViewPort} 
        onMapMove={onMapMove} 
        toggleShowPositioningBounds={toggleShowPositioningBounds}
        onSetServiceIds={onSetServiceIds}
        serviceIds={serviceIds}
        >
      <FitOnSearchChange/>
      {matchingEstateMarkers}
      {nonMatchingEstateMarkers}
      {groupMarkers}
      {poisMarkers}
      {servicesMarkers}
      <Boundaries/>
      <Paths/>
      <MapSetter/>
    </MapWithControls>;

    return map;
  }
}

const coordinatePropTypes = {
  lat: React.PropTypes.number.isRequired,
  lng: React.PropTypes.number.isRequired
}

MapWithEstates.propTypes = {
  defaultViewPort: React.PropTypes.shape({
    topLeft: React.PropTypes.shape(coordinatePropTypes).isRequired,
    bottomRight: React.PropTypes.shape(coordinatePropTypes).isRequired
  }).isRequired,
  onMapMove: React.PropTypes.func.isRequired,
  services: React.PropTypes.array.isRequired,
  serviceIds: React.PropTypes.array.isRequired,
  onSetServiceIds: React.PropTypes.func.isRequired,
}

const mapStateToProps = (state) => {
  return {
    //matchingEstates: matchingEstatesSelector(state),
    //nonMatchingEstates: nonMatchingEstatesSelector(state),
    defaultViewPort: state.defaultViewPort,
    estates: state.estates,
    groups: groupsSelector(state),
    listsOfEstates: listsOfEstatesSelector(state),
    estateListIdsIndex: state.estateListIdsIndex,
    services: state.services,
    serviceIds: state.serviceIds,
    updateSummaries: _ => {},
    zoom: state.zoom,
    viewPort: state.viewPort,
    estateMap: state.estateMap,
    sortedEstates: sortedEstateList(state),
    selectedEstateId: state.selectedEstateId,
    showBoundaries: state.show.boundaries
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onMapMove: (bounds, zoom) => {
      dispatch(updateViewPort(bounds, zoom))
    },
    onShowPositioningBounds: _ => dispatch(getPositioningBoundary()),
    onHideBoundaries: _ => dispatch(hideBoundaries()),
    onSetServiceIds: (serviceIds) => dispatch(setServiceIds(serviceIds)),
    updateSummaries: nonMatchingEstates => {
      dispatch(loadSummaries(R.map(x => x.id, nonMatchingEstates)))      
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(MapWithEstates)



/** WEBPACK FOOTER **
 ** ./app/components/MapWithEstates.jsx
 **/